import React from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getTypographyColorProps } from './getTypographyColorProps';
import { renderHeadingTextWithEmphasis } from './renderHeadingTextWithEmphasis';

const Heading4 = (props) => {
  const { color, children, ...rest } = props;
  const { typographyColor, colorStyle } = getTypographyColorProps(color);
  const formattedChildren = renderHeadingTextWithEmphasis(children, color);
  return (
    <HandleSmallDevices
      {...rest}
      component="h4"
      color={typographyColor}
      sx={[colorStyle, ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx])]}
    >
      {formattedChildren}
    </HandleSmallDevices>
  );
};
export default Heading4;

const HandleSmallDevices = styled(Typography)(({ theme }) => ({
  fontWeight: 100,
  [theme.breakpoints.up('md')]: {
    fontSize: '38px',
    lineHeight: '47.77px',
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  [theme.breakpoints.down('md')]: {
    fontSize: '35px',
    lineHeight: '44.275px',
    fontWeight: 600,
    textTransform: 'capitalize',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
    lineHeight: '32.275px',
    fontWeight: 600,
    textTransform: 'capitalize',
  },
}));
